import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, Tooltip, Input, Typography, Avatar } from '@app/ui';
import { FacebookOutlined, InstagramOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Text, Title } = Typography;

const platformIcon = (platformId: number, isSelected: boolean) => {
    const color = isSelected ? '#009FDF' : '#A3BDC7';
    const iconStyle = { color: '#FFFFFF', fontSize: 18 };

    switch (platformId) {
        case 3:
            return (
                <Avatar
                    style={{ backgroundColor: color }}
                    icon={<FacebookOutlined style={iconStyle} />}
                />
            );
        case 2:
            return (
                <Avatar
                    style={{ backgroundColor: color }}
                    icon={<InstagramOutlined style={iconStyle} />}
                />
            );
        default:
            return null;
    }
};

const AccountCards = ({
    authenticatedAccounts,
    selectedAccountId,
    setSelectedAccountId,
}: any) => {
    const { t } = useTranslation('ownedSocial');
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        if (authenticatedAccounts.length && selectedAccountId === null) {
            setSelectedAccountId(authenticatedAccounts[0].id);
        }
    }, [authenticatedAccounts, selectedAccountId]);

    const filteredAccounts = authenticatedAccounts.filter(account =>
        account.username.toLowerCase().includes(searchValue.toLowerCase()),
    );

    return (
        <div className="audience-element-wrapper ">
            <div className="audience-search-bar-inside">
                <ConfigProvider
                    theme={{
                        token: {
                            fontFamily: 'pnregular',
                        },
                    }}
                >
                    <Search
                        addonBefore={t('audience.searchAccount')}
                        placeholder={t('audience.search')}
                        value={searchValue}
                        onChange={e => setSearchValue(e.target.value)}
                        style={{ width: 463 }}
                    />
                </ConfigProvider>
            </div>

            <div className="audience-scroll-inner">
                {filteredAccounts.map(account => {
                    const isSelected = selectedAccountId === account.id;
                    return (
                        <div
                            key={account.id}
                            className={`audience-card ${isSelected ? 'selected' : ''}`}
                            onClick={() => setSelectedAccountId(account.id)}
                        >
                            <div className="account-container">
                                <div className="audience-icon">
                                    {platformIcon(
                                        account.platformId,
                                        isSelected,
                                    )}
                                </div>
                                <Tooltip title={`@${account.username}`}>
                                    <Text
                                        style={{
                                            fontFamily: 'pnsemibold',
                                            fontSize: 16,
                                            maxWidth: 120,
                                        }}
                                        ellipsis
                                    >
                                        @{account.username}
                                    </Text>
                                </Tooltip>
                            </div>
                            <div>
                                <Text
                                    style={{
                                        fontFamily: 'pnregular',
                                        fontSize: 14,
                                    }}
                                >
                                    {account.platformId === 3
                                        ? t('audience.platforms.facebook')
                                        : t(
                                              'audience.platforms.instagram',
                                          )}{' '}
                                    {t('audience.followers')}
                                </Text>
                            </div>
                            <Title
                                style={{ fontFamily: 'pnregular' }}
                                level={3}
                                className="follower-count"
                            >
                                {account.followerCount.toLocaleString()}
                            </Title>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AccountCards;
